<template>
	<div v-if="dataLoaded">
		<v-toolbar color="blue lighten-1" class="white--text">
			<v-icon color="white">business</v-icon>
			<v-toolbar-title>Dane projektu</v-toolbar-title>
		</v-toolbar>
		<div class="ma-4">
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Nazwa projektu</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					{{project.title}}
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Numer projektu</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					{{project.code}}
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Nazwa konkursu</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					{{project.contestName}}
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Czas trwania projektu</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					{{project.startDate}} - {{project.endDate}}
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Status projektu</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					{{project.status}}
				</v-flex>
			</v-layout>
		</div>
	</div>
</template>

<script>
	import {Project} from "../../../../api/generated/Project";

	export default {
		name: "ProjectSummaryDataView",

		data () {
			return {
				project: null,
				dataLoaded: false
			};
		},

		created () {
			this.getProjectSummaryMainData();
		},

		methods: {
			getProjectSummaryMainData () {
				Project.getSummaryMainData(this, this.$route.params.projectId, successResponse => {
						this.project = successResponse;
						this.dataLoaded = true;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować danych projektu", errorResponse);
					});
			}
		}
	};
</script>

<style scoped>

</style>